<template>
  <v-main class="home">
    <router-view
      :is-mobile="isMobile"
      :window-height="windowHeight"
    ></router-view>
  </v-main>
</template>

<script>
import { mapGetters } from "vuex";

import api from "@/api";
import Measure from "@/models/measure";
import User from "@/models/user";
import Device from "@/models/device";
import SiteGroup from "@/models/site_group";

export default {
  name: "Home",
  props: {
    isMobile: { type: Boolean, default: () => false },
    windowHeight: { type: Number, default: () => false },
  },
  computed: { ...mapGetters("user", { isAdmin: "isAdmin" }) },
  beforeRouteEnter(to, from, next) {
    api.measures.list().then((data) => Measure.insert({ data }));
    api.users.list().then((data) => User.insert({ data }));
    api.devices.list().then((data) => Device.insert({ data }));
    api.site_groups.list().then((data) => SiteGroup.insert({ data }));

    next();
  },
  destroyed() {
    this.$store.dispatch("entities/deleteAll");
  },
};
</script>
